const Actions = {
  SET_PAGE_HEADER: "SET_PAGE_HEADER",
};

export default Actions;
